import { createRouter, createWebHistory } from "vue-router";
import LinkookLiveView from "../views/home/HomeView.vue";
import LinkookLiveVideo from "../views/video/VideoList.vue";
import VideoDetail from "../views/video/VideoDetail.vue";
import LinkookLiveSignin from "../views/login/LinkookLiveSignin.vue";
import KakaoLogin from "../views/login/KakaoLogin.vue";
import XCallback from "../views/profile/XCallback.vue";
import LinkookLiveDetail from "../views/home/LiveDetail.vue";
import VisitorStats from "../views/admin/VisitorStats.vue";
import ArtistStats from "../views/admin/ArtistStats.vue";
import VenueStats from "../views/admin/VenueStats.vue";
import UserStats from "../views/admin/UserStats.vue";
import AdManagement from "../views/admin/AdManagement.vue";
import ReportManagement from "../views/admin/ReportManagement.vue";
import LikeStats from "../views/admin/LikeStats.vue";
import ActivityStats from "../views/admin/ActivityStats.vue";
import TrafficStats from "../views/admin/TrafficStats.vue";
import LiveStats from "../views/admin/LiveStats.vue";
import AlarmManagement from "../views/admin/AlarmManagement.vue";
import CoreUserStats from "../views/admin/CoreUserStats.vue";
import GrowthOverview from "../views/admin/GrowthOverview.vue";
import ArtistList from "../views/artist/ArtistList.vue";
import ArtistDetail from "../views/artist/ArtistDetail.vue";
import VenueList from "../views/venue/VenueList.vue";
import VenueDetail from "../views/venue/VenueDetail.vue";
import MyProfile from "../views/profile/MyProfile.vue";
import MyInfo from "../views/profile/MyInfo.vue";
import MyCalendar from "../views/profile/MyCalendar.vue";
import MyReservations from "../views/profile/MyReservations.vue";
import CommunityBoard from "../views/community/CommunityBoard.vue";
import WriteBoard from "../views/community/WriteBoard.vue";
import BoardDetail from "../views/community/BoardDetail.vue";
import TicketForm from "../views/ticket/TicketForm.vue";
import TicketFormAdmin from "../views/ticket/TicketFormAdmin.vue";
import TicketReservationList from "../views/ticket/TicketReservationList.vue";
import MyNotifications from "../views/alarm/MyNotifications.vue";
import CommissionList from "../views/commission/CommissionList.vue";
import CommissionDetail from "../views/commission/CommissionDetail.vue";
import NotFound from "../views/NotFound.vue";
import { useUserStore } from "@/store/user";
import { resetPageMeta } from "@/utils/pageMeta";

const routes = [
  {
    path: "/",
    name: "LinkookHome",
    component: LinkookLiveView,
  },
  {
    path: "/video",
    name: "VideoList",
    component: LinkookLiveVideo,
  },
  {
    path: "/video/:id",
    name: "VideoDetail",
    component: VideoDetail,
  },
  {
    path: "/signin",
    name: "LinkookSignin",
    component: LinkookLiveSignin,
  },
  {
    path: "/kakaoLogin",
    name: "KakaoLogin",
    component: KakaoLogin,
  },
  {
    path: "/x-callback",
    name: "XCallback",
    component: XCallback,
  },
  {
    path: "/live/:slug",
    name: "LiveDetail",
    component: LinkookLiveDetail,
  },
  {
    path: "/visitor-stats",
    name: "VisitorStats",
    component: VisitorStats,
    meta: { requiresAuth: true },
  },
  {
    path: "/artist-stats",
    name: "ArtistStats",
    component: ArtistStats,
    meta: { requiresAuth: true },
  },
  {
    path: "/venue-stats",
    name: "VenueStats",
    component: VenueStats,
    meta: { requiresAuth: true },
  },
  {
    path: "/user-stats",
    name: "UserStats",
    component: UserStats,
    meta: { requiresAuth: true },
  },
  {
    path: "/ad-management",
    name: "AdManagement",
    component: AdManagement,
    meta: { requiresAuth: true },
  },
  {
    path: "/report-management",
    name: "ReportManagement",
    component: ReportManagement,
    meta: { requiresAuth: true },
  },
  {
    path: "/alarm-management",
    name: "AlarmManagement",
    component: AlarmManagement,
    meta: { requiresAuth: true },
  },
  {
    path: "/like-stats",
    name: "LikeStats",
    component: LikeStats,
    meta: { requiresAuth: true },
  },
  {
    path: "/activity-stats",
    name: "ActivityStats",
    component: ActivityStats,
    meta: { requiresAuth: true },
  },
  {
    path: "/traffic-stats",
    name: "TrafficStats",
    component: TrafficStats,
    meta: { requiresAuth: true },
  },
  {
    path: "/live-stats",
    name: "LiveStats",
    component: LiveStats,
    meta: { requiresAuth: true },
  },
  {
    path: "/core-user-stats",
    name: "CoreUserStats",
    component: CoreUserStats,
    meta: { requiresAuth: true },
  },
  {
    path: "/growth-overview",
    name: "GrowthOverview",
    component: GrowthOverview,
    meta: { requiresAuth: true },
  },
  {
    path: "/artist",
    name: "ArtistList",
    component: ArtistList,
  },
  {
    path: "/artist/:slug",
    name: "ArtistDetail",
    component: ArtistDetail,
  },
  {
    path: "/venue",
    name: "VenueList",
    component: VenueList,
  },
  {
    path: "/venue/:name",
    name: "VenueDetail",
    component: VenueDetail,
  },
  {
    path: "/board",
    name: "CommunityBoard",
    component: CommunityBoard,
  },
  {
    path: "/board/write",
    name: "WriteBoard",
    component: WriteBoard,
    meta: { requiresAuth: true },
  },
  {
    path: "/board/:boardId",
    name: "BoardDetail",
    component: BoardDetail,
  },
  {
    path: "/profile",
    name: "Profile",
    component: MyProfile,
    meta: { requiresAuth: true },
  },
  {
    path: "/my-calendar",
    name: "MyCalendar",
    component: MyCalendar,
    meta: { requiresAuth: true },
  },
  {
    path: "/my-info",
    name: "MyInfo",
    component: MyInfo,
    meta: { requiresAuth: true },
  },
  {
    path: "/my-reservations",
    name: "MyReservations",
    component: MyReservations,
    meta: { requiresAuth: true },
  },
  {
    path: "/notifications",
    name: "MyNotifications",
    component: MyNotifications,
    meta: { requiresAuth: true },
  },
  {
    path: "/ticket/:id",
    name: "TicketForm",
    component: TicketForm,
    meta: { requiresAuth: true },
  },
  {
    path: "/ticket-admin/:id?",
    name: "TicketFormAdmin",
    component: TicketFormAdmin,
    meta: { requiresAuth: true },
  },
  {
    path: "/ticket-reservations/:id",
    name: "TicketReservationList",
    component: TicketReservationList,
    meta: { requiresAuth: true },
  },
  {
    path: "/commission",
    name: "CommissionList",
    component: CommissionList,
    meta: { requiresAuth: true },
  },
  {
    path: "/commission/:id",
    name: "CommissionDetail",
    component: CommissionDetail,
    meta: { requiresAuth: true },
  },
  { path: "/:pathMatch(.*)*", name: "NotFound", component: NotFound },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0, left: 0 };
  },
});

// 네비게이션 가드 추가
router.beforeEach((to, from, next) => {
  const userStore = useUserStore();

  // 인증이 필요한 페이지인지 확인
  if (to.meta.requiresAuth) {
    if (!userStore.isLogin) {
      next("/");
      return;
    }
  }

  next();
});

// 라우터 에러 핸들러 추가 (알림 표시용)
router.onError((error) => {
  console.error('Router error:', error);
});

// Detail 페이지 목록 (이동 대상이 이게 아니면 메타를 사이트 기본값으로 복구)
const DETAIL_ROUTE_NAMES = [
  "VideoDetail",
  "LiveDetail",
  "ArtistDetail",
  "VenueDetail",
  "BoardDetail",
  "CommissionDetail",
];

// 라우터 후처리 (알림 표시, 메타 복구)
router.afterEach((to, from, failure) => {
  if (failure) {
    return;
  }

  // Detail이 아닌 페이지로 나가면 og/타이틀을 사이트 기본값으로 되돌림 (탭·북마크 시 일관성)
  if (!DETAIL_ROUTE_NAMES.includes(to.name)) {
    resetPageMeta();
  }

  // 인증이 필요한 페이지에서 홈으로 리다이렉트된 경우 알림 표시
  if (to.path === "/" && from.meta.requiresAuth) {
    // Vue 인스턴스가 완전히 마운트된 후에 알림 표시
    setTimeout(() => {
      if (window.$alert) {
        window.$alert("로그인이 필요합니다");
      }
    }, 200);
  }
});

export default router;
